<style lang="scss" scoped>
.slideout-shopping-basket {
    h2 {
        font-weight: 900;
        font-size: 1.25rem;
        line-height: 1.625rem;

        @media screen and (min-width: 1024px) {
            font-size: 1.5rem;
            line-height: 2.3125rem;
        }
    }
}
</style>

<template>
    <div class="slideout-shopping-basket flex flex-1">
        <div class="flex flex-col items-stretch justify-between flex-1">
            <div class="md:py-80 md:px-40 px-20 pt-56 pb-24">
                <h2 class="mb-16 text-gray-800">{{ translations.shopping_basket_title }}</h2>
                <div v-if="message != null && message != ''" class="bg-blue rounded-xs text-14 lg:mb-16 flex items-center w-full px-16 py-16 mb-24 font-medium leading-snug text-white transition-opacity">
                    <span v-html="svg('plus-circle', 'mr-16')"></span>
                    <span v-html="message"></span>
                </div>
                <div class="flex mb-16" v-for="product in this.basket.products" :key="product.id">
                    <img class="w-80 h-80 rounded-xs object-cover object-center mr-16" :src="getFirstImage(product.productData)" :alt="product.productData.name" />
                    <div class="flex flex-col py-8">
                        <p class="text-16 mb-8 font-bold text-gray-800">
                            <span>{{ product.amount }}x</span> <span v-html="product.productData.name"></span>
                        </p>
                        <div class="flex flex-wrap items-center">
                            <span class="text-14 font-medium leading-tight text-gray-500">&euro; {{ formatCurrency(getVariantPrice(product, $store.getters["pricesIncludingVat"])) }}</span>
                            <span class="text-10 mx-8 font-medium text-gray-500">•</span>
                            <a :href="`/product/${product.productData.slug}`" class="text-14 hover:border-transparent font-medium leading-tight text-gray-500 transition-colors border-b border-gray-500">{{ translations.view_product }}</a>
                        </div>
                        <div class="flex flex-wrap items-center mt-8">
                            <template v-for="option in product.productData.options.filter(o => o.type !== 'opp_calc')">
                                <span class="text-14 font-medium leading-tight text-gray-500" :key="option.key">{{ product.variant.content[option.key] }}</span>
                                <span class="text-10 last:hidden mx-8 font-medium text-gray-500" :key="`${option.key}_bull`">•</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md:px-40 px-20 py-32 border-t border-gray-300">
                <div class="flex justify-between mb-8">
                    <span class="text-black">{{ translations.subtotal }}</span>
                    <span class="text-gray-500">&euro; {{ subTotal }}</span>
                </div>
                <div class="flex justify-between mb-8">
                    <span class="text-black">{{ translations.vat }}</span>
                    <span class="text-gray-500">&euro; {{ vat }}</span>
                </div>
                <div class="flex justify-between mb-24">
                    <span class="text-black">{{ translations.shipping }}</span>
                    <span class="text-gray-500">Volgende stap</span>
                </div>
                <div class="flex justify-between mb-24">
                    <span class="text-20 font-bold text-black">{{ translations.total }}</span>
                    <span class="text-gray-500">&euro; {{ totalPrice }}</span>
                </div>
                <div class="text-center">
                    <a href="/winkelmandje" class="btn btn-green btn-rounded w-full mb-24">{{ translations.submit_button_slideout }}</a>
                    <a href="#" @click.prevent="close" class="hover:border-transparent font-bold leading-tight text-black transition-colors border-b border-black">{{ translations.continue_shopping_link }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from "@/app";
import shoppingBasket from "@mixins/components/shopping-basket";

export default {
    name: "Ui.SlideoutShoppingBasket",

    mixins: [shoppingBasket],

    data() {
        return {
            message: ""
        };
    },

    mounted() {
        const self = this;

        bus.$on("shopping-basket-message", message => {
            self.message = message;
        });

        this.$store.dispatch("syncBasketProducts");
    },

    methods: {
        close() {
            bus.$emit("slideout-close");
        }
    }
};
</script>
